module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/884c0d7bca620c451298fde7f1142afb.png";